<template>
  <v-dialog
    :value="isDeletarComponenteDialogOpen"
    persistent
    max-width="500"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title class="headline">
        Deletar componente
      </v-card-title>

      <v-card-text>
        Tem certeza que deseja deletar o componente?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          outlined
          @click="closeDialog"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="success"
          @click="deletarComponente"
        >
          <v-progress-circular
            v-if="loading"
            class="mx-3"
            indeterminate
            color="secundary"
          />
          <span v-else>ok</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import router from '@/router'
import FormularioService from '@/services/modules/FormularioService'
import useDialog from '@/composables/useDialog'

export default {
  props: {
    isDeletarComponenteDialogOpen: {
      type: Boolean,
      required: true,
    },
    secaoId: {
      type: Number,
      required: true,
    },
    componenteId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { loading, closeDialog } = useDialog(emit, 'is-deletar-componente-dialog-open')

    async function deletarComponente() {
      try {
        loading.value = true
        await FormularioService.deletarComponente(router.currentRoute.params.id, props.secaoId, props.componenteId)
        emit('refetch-data')
        closeDialog()
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      closeDialog,
      deletarComponente,
    }
  },
}
</script>
